"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Allows application to register tokens to cloud
 * on members when application is booted
 */
const registerAppCloudMessagingToken = async ({ appId, projectId, processor, }) => {
    try {
        let token;
        try {
            token = await processor.root.firebase.messaging().getToken();
        }
        catch (error) {
            await processor.root.firebase.messaging().registerDeviceForRemoteMessages();
            token = await processor.root.firebase.messaging().getToken();
        }
        if (!token) {
            return;
        }
        // The token is not registered on cloud yet
        const response = await processor.root.cloud.rendererUpdateCloudMessageToken({
            appId,
            messageToken: token,
            projectId,
        });
        if (!response.success) {
            switch (response.errorCode) {
                case 'NO_USER_AUTHENTICATED':
                    // user not authenticated
                    break;
                default:
                    processor.root.alert('Error when sending', response.errorMessage);
            }
        }
    }
    catch (error) {
        if (processor.root.isInDevelopment) {
            processor.root.alert('Register cloud messaging token error', `${error}`);
        }
    }
};
exports.default = registerAppCloudMessagingToken;
